import { Injectable, signal } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class AgeGateService {

  isBrowser = typeof window !== 'undefined';

  ageVerified = signal<boolean>(true); // SSR-safe default

  constructor(private router:Router) {
    if (this.isBrowser) {
      this.syncFromStorage();
      window.addEventListener('storage', this.syncFromStorage);
    }
  }

  private syncFromStorage = () => {
    this.ageVerified.set(
      localStorage.getItem('ageVerified') === 'true'
    );
  };

  confirm() {
    localStorage.setItem('ageVerified', 'true');
    this.ageVerified.set(true);
    this.router.navigateByUrl('/').then(()=>{
        window.location.reload()
    })
  }

  deny() {
    localStorage.removeItem('ageVerified');
    this.ageVerified.set(false);
      window.location.href = 'https://www.google.com';

  }
}
